//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="go_faqs">
    <h2>{{ store.state.page.faq_assets.faq_title }}</h2>
    <div class="go_faq_list_container">
      <div
        v-for="(faq, index) in faqs"
        :key="index"
        class="go_faq_container"
        :style="{
          borderBottom: store.state.Style.themeColor,
          borderBottomWidth: '1.2px',
          borderBottomStyle: 'solid',
        }"
      >
        <div class="question_wrapper" @click="toggleQuestion(index)">
          <div
            class="go_question"
            :style="{ color: store.state.Style.themeColor }"
          >
            {{ faq.question }}
          </div>
          <MinusIcon v-if="faq.isQuestionOpen" />
          <PlusIcon v-else />
        </div>
        <div v-if="faq.isQuestionOpen" class="go_answer">{{ faq.answer }}</div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useStore } from "vuex";
import { defineProps, ref } from "vue";

import MinusIcon from "@/components/icons/MinusIcon.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";

const props = defineProps({
  additionalFaqs: {
    default: null,
  },
});
const store = useStore();

const faqs = ref([
  {
    question: store.state.page.faq_assets.how_app_works_question,
    answer: store.state.page.faq_assets.how_app_works_answer,
    isQuestionOpen: false,
  },
  {
    question: store.state.page.faq_assets.how_long_question,
    answer: store.state.page.faq_assets.how_long_answer,
    isQuestionOpen: false,
  },
  {
    question: store.state.page.faq_assets.who_can_use_question,
    answer: store.state.page.faq_assets.who_can_use_answer,
    isQuestionOpen: false,
  },
  {
    question: store.state.page.faq_assets.app_is_fda_ce_question,
    answer: store.state.page.faq_assets.app_is_fda_ce_answer,
    isQuestionOpen: false,
  },
  {
    question: store.state.page.faq_assets.who_created_question,
    answer: store.state.page.faq_assets.who_created_answer,
    isQuestionOpen: false,
  },
]);

if (props.additionalFaqs) {
  faqs.value = faqs.value.concat(props.additionalFaqs);
}

function toggleQuestion(index) {
  faqs.value[index].isQuestionOpen = !faqs.value[index].isQuestionOpen;
}
</script>

<style lang="scss" scoped>
.go_faqs {
  width: 100%;
  background-color: rgba(21, 25, 46, 0.05);

  h2 {
    margin-top: 45px;
    margin-bottom: 70px;

    @include tablet {
      margin-bottom: 57px;
    }

    @include mobile {
      margin-top: 28px;
      margin-bottom: 25px;
    }
  }
  .go_faq_list_container {
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;

    .go_faq_container {
      width: 1000px;
      text-align: left;
      margin: 0 0 20px;
      padding: 0 0 20px;
      &:last-child {
        border-bottom: none;
      }

      @include tablet {
        width: 823px;
      }

      @include mobile {
        width: 350px;
      }

      .question_wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .go_question {
          font-weight: 500;
          font-size: 20px;
          line-height: 30px;
          @include tablet {
            font-size: 16px;
            line-height: 25px;
          }

          @include mobile {
            font-size: 14px;
            line-height: 25px;
          }
        }

        svg {
          width: 14px;

          @include tablet {
            width: 12px;
          }
          @include mobile {
            width: 12px;
          }
        }
      }

      .go_answer {
        font-weight: 300;
        font-size: 17.0333px;
        line-height: 30px;

        @include tablet {
          font-size: 14px;
          line-height: 25px;
        }

        @include mobile {
          font-size: 10px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
